import { isEmpty } from "lodash";

import { colorsPalettes } from "@similarweb/styles";

import type { PieChartDataItemType } from "app/pages/website-analysis/traffic-sources/display-ads/common/PieChart";

type SiteData = Record<string, number>;

export const transformAdNetworksPieChartData = (data: SiteData): PieChartDataItemType[] => {
    if (isEmpty(data)) {
        return [];
    }

    const totalValues = Object.values(data).reduce((total: number, item: number) => total + item, 0);
    const dataArray = Object.entries(data).map(([name, value]: [string, number]) => ({
        y: value,
        percent: value,
        name,
    }));

    return totalValues < 1
        ? [
              ...dataArray.sort((a, b) => (b.y > a.y ? 1 : -1)),
              {
                  y: 1 - totalValues,
                  percent: 1 - totalValues,
                  name: "Others",
                  color: colorsPalettes.carbon[50],
              },
          ]
        : dataArray;
};
